import React, { useState } from 'react';
import { Link } from 'react-router';
import Button from '../components/ui/Button';
import AuthLayout from '../components/AuthLayout';
import { useForgotPassword } from '../hooks/useAuth';
import { useLanguage } from '../lang/LangContext';
import { KEYS } from '../lang/keys';

const ForgotPassword = () => {
    const { t } = useLanguage();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const forgotPassword = useForgotPassword();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await forgotPassword.mutateAsync(email);
            setSent(true);
        } catch (err) {
            setError(err.message || t(KEYS.COMMON_ERROR_GENERIC));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout subtitle={t(KEYS.FORGOT_PASSWORD_TAGLINE)}>
            {sent ? (
                <div className="space-y-4">
                    <div className="p-3 bg-status-paid/10 text-status-paid rounded-md text-sm border border-status-paid/20 animate-appear">
                        {t(KEYS.FORGOT_PASSWORD_SENT).replace('{email}', email)}
                    </div>
                    <p className="text-sm text-text-muted text-center">
                        {t(KEYS.FORGOT_PASSWORD_CHECK_SPAM)}{' '}
                        <button
                            onClick={() => setSent(false)}
                            className="text-accent hover:text-accent-hover font-medium"
                        >
                            {t(KEYS.FORGOT_PASSWORD_TRY_AGAIN)}
                        </button>
                        .
                    </p>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <p className="text-sm text-text-muted">
                        {t(KEYS.FORGOT_PASSWORD_DESCRIPTION)}
                    </p>

                    <div className="space-y-1.5">
                        <label htmlFor="email" className="label-base">
                            {t(KEYS.COMMON_EMAIL)}
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="input-base"
                            placeholder="you@example.com"
                            disabled={loading}
                        />
                    </div>

                    {error && (
                        <div className="p-3 bg-status-overdue-bg text-status-overdue rounded-md text-sm border border-status-overdue/20 animate-appear">
                            {error}
                        </div>
                    )}

                    <Button type="submit" variant="primary" fullWidth disabled={loading}>
                        {loading ? t(KEYS.FORGOT_PASSWORD_SUBMITTING) : t(KEYS.FORGOT_PASSWORD_SUBMIT)}
                    </Button>
                </form>
            )}

            <div className="mt-5 pt-5 border-t border-surface-border text-center">
                <p className="text-sm text-text-muted">
                    <Link to="/login" className="text-accent hover:text-accent-hover font-medium">
                        {t(KEYS.COMMON_BACK_TO_LOGIN)}
                    </Link>
                </p>
            </div>
        </AuthLayout>
    );
};

export default ForgotPassword;
